"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestSkippedError = void 0;
const exceptions_1 = require("@sigmasms/shared-types/exceptions");
const sue_exception_1 = require("../sue.exception");
class RequestSkippedError extends sue_exception_1.SueException {
}
exports.RequestSkippedError = RequestSkippedError;
RequestSkippedError.httpStatus = exceptions_1.HttpStatus.REQUEST_SKIPPED_ERROR;
//# sourceMappingURL=request-skipped-error.exception.js.map